import React, { Component } from 'react';
import { sortBy } from 'lodash';

import LoadingIndication from '../../common/loading-indicator';
import adminStatsService from '../../../services/admin-stats/admin-stats';
import { Chart } from './bar-chart';

function convertToObjectForEachTag(stats) {
  const tags = Object.keys(stats[0]).filter(x=>x!=='date');
  return sortBy(tags.map(tag => {
    const total = stats.reduce((total, dayData) => {
      return total + dayData[tag];
    }, 0);

    return {
      tag,
      total,
    };
  }), 'total').reverse();
}

class WeeklyBarChartOvertimeStats extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isError: false,      
      stats: [],
    };
  }

  componentDidMount() {
    const { metricPrefix } = this.props;
    adminStatsService.getStatsTagsOverTimeByNumOfDays(metricPrefix, 7)
      .then((stats) => {
        this.setState(() => {
          const convertedData = convertToObjectForEachTag(stats);
          return {
            isLoading: false,
            isError: false,
            stats: convertedData,
            xKeys: ['total'],
          };
        }); 
      })
      .catch(error => {
        console.error('WeeklyBarChartOvertimeStats::componentDidMount', error);
        this.setState({
          isLoading: false,
          isError: true
        });
      });
  }

  render() {
    if (this.state.isLoading) {
      return <LoadingIndication />;
    }

    if (this.state.isError) return <div>Error</div>;

    const { stats, xKeys } = this.state;

    const statsSeparation = [];
    const tagsPerChart = 8;
    for (let i = 0; i < stats.length; i += tagsPerChart) {
      statsSeparation.push(stats.slice(i, i + tagsPerChart));
    }     

    return (
      <div style={{ margin: '30px 0' }}>
        {
          statsSeparation.map(chartStats => (
            <Chart stats={chartStats} xKeys={xKeys} />
          ))
        }
      </div>
    );
  }
}

export default WeeklyBarChartOvertimeStats;
